// [DEPRECATED_GRAPHQL] - Para eliminación: Notification usa alertStore que usa GraphQL queries
// TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente

/*
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import Widget from "./Widget";
import {
  NotificationWrapper,
  NotificartionTitle,
  NotificartionDescription,
  NotificationTypeWrapper,
  NotificationActions,
  NotificationMarkCompleted,
  NotificationContainer,
  Loading,
  NotificationStatusWrapper,
  NotificationsStatus,
  NotificationAssignedWrapper,
  NotificationAssigned,
  StyledPersonIcon,
  AssignToMeButton,
  NotificationButtons
} from "./Widget.styled";
import { useStore } from "../../../../../hooks";
import { observer } from "mobx-react";
import Spinner from "../../../../../components/common/Spinner";
import Alerts from "../../../../../elements/v2/Alerts/Alerts";
import NoDataAvailable from "./NoDataAvailable";
import { formatWeekDayMonthTime } from "../../../../../utils/useDateFormat";
import { toTitleCase } from "../../../../../utils/uiUtils";
import { RowStatus } from "../../../../../utils/enums";
import { useUserCheckPermissions } from "../../../../../hooks/useUserCheckPermissions";
import { PermissionCodes } from "../../../../../utils/enums";

const Notification = observer(() => {
  const { alertStore, contactStore, authStore } = useStore();
  const [alerts, setAlerts] = useState(alertStore.alertNotification);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [nextPage, setNextPage] = useState(
    alertStore.lastEvaluatedKey,
  );
  const [contactsData, setContactsData] = useState({});
  const [isContactValid, setIsContactValid] = useState(false);
  const observer = useRef();
  const lastNotificationRef = useRef();
  const notificationContainerRef = useRef();

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { checkPermission } = useUserCheckPermissions();
  const normalizeStatus = (status) => {
    if (status === RowStatus.UNRESOLVED_RAW) return RowStatus.UNRESOLVED;
    if (status === RowStatus.RESOLVED_RAW) return RowStatus.RESOLVED;
    return status;
  };

  const updateAlertInList = useCallback((alerts, targetId, updates) => {
    return alerts.map((alert) => {
      if (alert.id !== targetId) return alert;
      
      return {
        ...alert,
        ...updates,
        payload: {
          ...alert.payload,
          ...updates.payload
        }
      };
    });
  }, []);

  const updateAlertStatus = useCallback((id, status) => {
    setAlerts((prevAlerts) => ({
      ...prevAlerts,
      items: updateAlertInList(prevAlerts.items, id, { status })
    }));
  }, [updateAlertInList]);

  const updateAlertContactId = useCallback((notificationId, contactId) => {
    setAlerts(prevAlerts => ({
      ...prevAlerts,
      items: updateAlertInList(prevAlerts.items, notificationId, {
        payload: { contact_id: contactId }
      })
    }));
  }, [updateAlertInList]);

  const fetchContactData = useCallback(async (contactId) => {
    if (!contactId || contactsData[contactId]) return;
    
    try {
      const response = await contactStore.getSingleContact(authStore.selectedAccount.id, contactId);
      if (response?.data?.getSingleContact?.body) {
        const contactData = JSON.parse(response.data.getSingleContact.body);
        setContactsData(prev => ({
          ...prev,
          [contactId]: contactData
        }));
      }
    } catch (error) {
      setErrorMessage("Error fetching contact data");
      setShowErrorModal(true);
    }
  }, [authStore.selectedAccount.id, contactStore, contactsData]);

  const handleIsCompleted = useCallback(
    (id, status) => {
      return async () => {
        try {
          const currentStatus = normalizeStatus(status);
          const newStatus = currentStatus === RowStatus.UNRESOLVED ? RowStatus.RESOLVED : RowStatus.UNRESOLVED;
          
          const currentAlert = alertStore.alertNotification.items.find(alert => alert.id === id);
          const currentContactId = currentAlert?.payload?.contact_id;

          await alertStore.updateAlert(
            id, 
            authStore.selectedAccount.id, 
            newStatus,
            currentAlert?.assignee,
            currentContactId
          );
          
          await updateAlertStatus(id, newStatus);
        } catch (error) {
          await updateAlertStatus(id, status);
          setErrorMessage("Error updating alert");
          setShowErrorModal(true);
        }
      };
    },
    [alertStore, authStore.selectedAccount.id, updateAlertStatus]
  );

  const handleAssignToMe = useCallback(async (notificationId) => {
    try {
      const currentAlert = alerts.items.find(alert => alert.id === notificationId);

      await alertStore.updateAlert(
        notificationId, 
        authStore.selectedAccount.id, 
        normalizeStatus(currentAlert.status),
        authStore.userId,
        alertStore.segmentId
      );
      await fetchContactData(alertStore.segmentId);
      updateAlertContactId(notificationId, alertStore.segmentId);
    } catch (error) {
      updateAlertContactId(notificationId, '');
      setErrorMessage("Error assigning the user");
      setShowErrorModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertStore, authStore.selectedAccount.id, alerts.items, fetchContactData, updateAlertContactId]);



  useEffect(() => {
    if (alerts.items) {
      alerts.items.forEach(notification => {
        if (notification.payload?.contact_id) {
          fetchContactData(notification.payload.contact_id);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alerts.items, fetchContactData]);

  useEffect(() => {
    setAlerts(alertStore.alertNotification);
    setNextPage(alertStore.lastEvaluatedKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertStore.alertNotification]);

  useEffect(() => {
    if (!nextPage) {
      if (observer.current && lastNotificationRef.current) {
        observer.current.unobserve(lastNotificationRef.current);
      }
      return;
    }

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };

    const observerCallback = async(entries) => {
      if (entries[0].isIntersecting && nextPage) {
        const currentScrollTop = notificationContainerRef.current.scrollTop;
        const currentScrollHeight =
          notificationContainerRef.current.scrollHeight;
        setIsLoadingMore(true);
        await alertStore
          .fetchNotificationsUCP(
            alertStore.accountId,
            alertStore.userId,
            nextPage,
          )
          .then(() => {
            setIsLoadingMore(false);

            if (notificationContainerRef.current) {
              const newScrollHeight =
                notificationContainerRef.current.scrollHeight;
              const scrollDiff = newScrollHeight - currentScrollHeight;
              notificationContainerRef.current.scrollTop =
                currentScrollTop + scrollDiff;
            }
          });
      }
    };

    observer.current = new IntersectionObserver(observerCallback, options);
    if (lastNotificationRef.current) {
      observer.current.observe(lastNotificationRef.current);
    }

    return () => {
      if ((lastNotificationRef || {}).current) {
        observer.current.unobserve((lastNotificationRef || {}).current);
      }
    };
  }, [nextPage, alertStore]);

  useEffect(() => {
    const checkContactExists = async () => {
      if (!alertStore.segmentId) {
        setIsContactValid(false);
        return;
      }

      try {
        const response = await contactStore.getSingleContact(authStore.selectedAccount.id, alertStore.segmentId);
        if (response?.data?.getSingleContact?.body) {
          setIsContactValid(true);
        } else {
          setIsContactValid(false);
        }
      } catch (error) {
        setErrorMessage("Error checking contact");
        setShowErrorModal(true);
        setIsContactValid(false);
      }
    };

    checkContactExists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertStore.segmentId, authStore.selectedAccount.id]);

  const sortedAlerts = useMemo(() => {
    if (!alerts.items) return [];
    return [...alerts.items].sort((a, b) => {
      return new Date(b.created_date) - new Date(a.created_date);
    });
  }, [alerts.items]);

  return (
    <>
      <Widget title="Notification" height="220px" maxheight={"730px"} padding={"12px"} cardType="alerts">
        {alertStore.isLoading ? (
          <Spinner />
        ) : !isContactValid ? (
          <NoDataAvailable/>
        ) : alerts.items && alerts.items.length > 0 ? (
          <NotificationContainer ref={notificationContainerRef}>
            {sortedAlerts.map((notification, index) => (
              <>
                <NotificationWrapper
                    key={notification.id}
                    isCompleted={notification.status === RowStatus.RESOLVED}
                    ref={
                      index === sortedAlerts.length - 1 ? lastNotificationRef : null
                    }
                >
                  <NotificationStatusWrapper>
                    <NotificationsStatus status={normalizeStatus(notification.status)}>
                      {normalizeStatus(notification.status)}
                    </NotificationsStatus>
                  </NotificationStatusWrapper>
                  <NotificartionTitle>
                    {notification.title}
                  </NotificartionTitle>
                  <NotificartionDescription title={notification.message}>
                    {notification.message}
                  </NotificartionDescription>
                  <NotificationTypeWrapper>
                    <span>
                      {formatWeekDayMonthTime(notification.created_date)}
                    </span>
                  </NotificationTypeWrapper>
                  <NotificationActions>
                    <NotificationAssignedWrapper>
                      <StyledPersonIcon />
                      <NotificationAssigned>
                        {!notification.payload || !notification.payload.contact_id || notification.payload.contact_id === '' ? 'Unassigned' : (toTitleCase(contactsData[notification.payload.contact_id]?.full_name) || '')}
                      </NotificationAssigned>
                    </NotificationAssignedWrapper>
                    <NotificationButtons>
                      {checkPermission(PermissionCodes.UCP_NOTIFICATIONS, "UPDATE") && (
                        <>
                          {(!notification.payload?.contact_id || notification.payload.contact_id === '') && (
                            <AssignToMeButton onClick={() => handleAssignToMe(notification.id)}>
                              Assign to me
                            </AssignToMeButton>
                          )}
                          <NotificationMarkCompleted
                            onClick={handleIsCompleted(notification.id, notification.status)}
                            isCompleted={notification.status === RowStatus.RESOLVED}
                          >
                            {normalizeStatus(notification.status) === RowStatus.RESOLVED
                              ? "Reopen"
                              : "Complete"}
                          </NotificationMarkCompleted>
                        </>
                      )}
                    </NotificationButtons>
                  </NotificationActions>
                </NotificationWrapper>
              </>
            ))}
            {isLoadingMore && (
              <Loading>
                <Spinner />
              </Loading>
            )}
          </NotificationContainer>
        ) : (
          <NoDataAvailable/>
        )}
      </Widget>
      {showErrorModal && errorMessage && (
        <Alerts
          isOpen={true}
          onClose={() => setShowErrorModal(false)}
          title="Error"
          message={errorMessage}
          severity="error"
          width="400px"
          top={"61px"}
          right={"16px"}
        />
      )}
    </>
  );
});

export default Notification;
*/

// Placeholder para evitar errores de importación
const Notification = () => null;
export default Notification;
